import React from 'react';
import Model from '../../components/Model';

export default function General() {
  return (
    <Model
      title={'General Usability'}
      src={'/video/mobile/conventional-general-usability.mp4'}
      para1={
        'It’s important to keep general usability similar to other known social media applications. A lot of users with cognitive disabilities have already learned to use popular apps, so it’s important to keep a sense of familiarity to the flow and functionality of Accessibee.'
      }
    />
  );
}
